var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKutumbNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-house-XJ53QBRVTC 1",
    clipPath: "url(#clip0_735_4864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14-House"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.715 9.16502L12.465 0.16502C12.332 0.0585172 12.1667 0.000488281 11.9963 0.000488281C11.8258 0.000488281 11.6605 0.0585172 11.5275 0.16502L0.2775 9.16502C0.156135 9.26239 0.0680565 9.39509 0.025468 9.54474C-0.0171205 9.69439 -0.0121105 9.85359 0.0398037 10.0003C0.091718 10.1469 0.187966 10.2738 0.315214 10.3634C0.442461 10.4529 0.594407 10.5007 0.75 10.5H2.25V23.25C2.25 23.4489 2.32902 23.6397 2.46967 23.7803C2.61032 23.921 2.80109 24 3 24H18V22.5H15V15.75C15 15.5511 14.921 15.3603 14.7803 15.2197C14.6397 15.079 14.4489 15 14.25 15H9.75C9.55109 15 9.36032 15.079 9.21967 15.2197C9.07902 15.3603 9 15.5511 9 15.75V22.5H3.75V10.5H16.5V9.00002H2.8875L12 1.71002L21.1125 9.00002H21C20.8011 9.00002 20.6103 9.07904 20.4697 9.21969C20.329 9.36034 20.25 9.55111 20.25 9.75002V14.25H21.75V10.5H23.25C23.405 10.4991 23.5558 10.4503 23.6819 10.3601C23.8079 10.27 23.903 10.1431 23.9539 9.99673C24.0049 9.8504 24.0093 9.69187 23.9665 9.54294C23.9237 9.39401 23.8359 9.26198 23.715 9.16502ZM10.5 16.5H13.5V22.5H10.5V16.5Z",
    fill: "#3A0CA3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.7501 19.9425L17.7826 18.975L16.7251 20.0325L18.2251 21.5325C18.3656 21.6722 18.5557 21.7506 18.7538 21.7506C18.952 21.7506 19.1421 21.6722 19.2826 21.5325L23.7826 17.0325L22.7251 15.975L18.7501 19.9425Z",
    fill: "#3A0CA3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_4864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKutumbNavLogo);
export default __webpack_public_path__ + "static/media/kutumb-nav-logo.b842483caf7477ff2b9f42593b052ba7.svg";
export { ForwardRef as ReactComponent };